export default __webpack_public_path__ + "static/media/pic52.a299b99c.JPG";